interface ReceiverDetailsIconProps {
    /** green when the receiver reported nothing against what was sent (same quantity, same measurements, no items returned), red otherwise */
    isMatched: boolean;
    onClick: () => void;
}

/** The "Receiver Details" action icon of the TBS lists (Send For TBS and TBS Store). */
export default function ReceiverDetailsIcon({ isMatched, onClick }: ReceiverDetailsIconProps) {
    return (
        <span
            className="cursor-pointer d-inline-flex align-items-center justify-content-center"
            title="Receiver Details"
            onClick={onClick}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke={isMatched ? "#28a745" : "#dc3545"}
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                <path d="M9 14l2 2l4 -4" />
            </svg>
        </span>
    );
}
